import React, { useEffect, useRef } from 'react';
import { useScoreboard } from './context/ScoreboardContext';
import { initBuzzer, playBuzzer } from './sounds/buzzer';

const TimeoutOverlay = ({ onTimeoutEnd, isLiveView = false }) => {
  const { centralTick, activeTimeout } = useScoreboard();
  const prevTimeLeftRef = useRef(activeTimeout?.timeLeft ?? 60);

  useEffect(() => {
    // Initialize buzzer when component mounts
    initBuzzer();
  }, []);

  useEffect(() => {
    const current = activeTimeout?.timeLeft ?? 60;
    // Edge-trigger buzzer at transition 16 -> 15 for control view
    if (!isLiveView && prevTimeLeftRef.current === 16 && current === 15) {
      playBuzzer();
    }
    prevTimeLeftRef.current = current;
  }, [centralTick, activeTimeout, isLiveView]);

  const formatTime = (seconds) => {
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
  };

  return (
    <>
      {isLiveView ? (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-1/3 py-8 px-6 flex flex-col items-center">
            <h2 className="font-bold text-black mb-4 text-[6vh]">
              Timeout
            </h2>
            <div className={`font-bold mb-4 text-[15vh] ${(activeTimeout?.timeLeft ?? 60) <= 15 ? 'text-red-500' : 'text-black'}`}>
              {formatTime(activeTimeout?.timeLeft ?? 60)}
            </div>
          </div>
        </div>
      ) : (
        <div className="fixed bottom-16 left-4 w-[180px] flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full p-3 flex flex-col items-center">
            <h2 className="font-bold text-black mb-4 text-lg">
              Timeout
            </h2>
            <div className={`font-bold mb-4 text-3xl ${(activeTimeout?.timeLeft ?? 60) <= 15 ? 'text-red-500' : 'text-black'}`}>
              {formatTime(activeTimeout?.timeLeft ?? 60)}
            </div>
            <button
              onClick={onTimeoutEnd}
              className="px-4 py-2 bg-amber-500 text-black text-base font-bold rounded-lg hover:bg-amber-600 w-full"
            >
              End Timeout
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TimeoutOverlay;
